'use strict';
const angular = require('angular');

/*@ngInject*/
export function formatTimeFilter() {
  return function(input) {
    let split = input.split(':');
    let hours = split[0] * 1;
    let minutes = split[1];
    let meridiem = 'am';

    if(hours > 12) {
      meridiem = 'pm';
      hours = hours - 12;
    } else if(hours == 12) {
      meridiem = 'pm';
    } else if(hours == 0) {
      hours = 12;
    }

    return `${hours}:${minutes}${meridiem}`;
  };
}


export default angular.module('fiapiApp.formatTime', [])
  .filter('formatTime', formatTimeFilter)
  .name;



// WEBPACK FOOTER //
// ./client/filters/formatTime/formatTime.filter.js